import BrandsCarousel from "../BrandsCarousel";
import LogosCarousel from "../LogosCarousel";
import  TitleComponent from "../SectionTitle"
import {
  BrandsSection,
  BrandsBoxTexts,
  BrandsBoxCarousel,
  LogosBoxCarousel,
  BrandsBoxTextsContent,
} from "./style";

const BrandsComponent = () => {

  return (
    <BrandsSection id="Marcas">
      <BrandsBoxTexts>
        <BrandsBoxTextsContent>
          <TitleComponent TitleText={'Ações do grupo e das marcas'} SubTitleText={'Confira alguns movimentos sustentáveis do grupo e das nossas marcas, que fazem a diferença.'} />
        </BrandsBoxTextsContent>
        <LogosBoxCarousel>
          <LogosCarousel />
        </LogosBoxCarousel>
      </BrandsBoxTexts>
      <BrandsBoxCarousel>
        <BrandsCarousel />
      </BrandsBoxCarousel>
    </BrandsSection>
  );
};

export default BrandsComponent;
